export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7033.402796d6.jpg";